import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

type Leader = {
  leader_name: string;
  leader_position: string;
  leader_slug: string;
  banner_image: string;
};

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
})
export class AboutUsComponent implements OnInit {

  leaders: Leader[] = [
    {
      leader_name: 'Mr. Sanjiv Bajaj sir',
      leader_position: 'Managing Director',
      leader_slug: 'sanjivbajaj',
      banner_image:
        'https://image.bajajcapitalone.com/bajajcapital/sb-bajaj_0.jpg',
    },
    {
      leader_name: 'Mr. Rajiv Bajaj sir',
      leader_position: 'Managing Director',
      leader_slug: 'rajivbajaj',
      banner_image:
        'https://image.bajajcapitalone.com/bajajcapital/profile-rb-bajaj_0.jpg',
    },
  ];
  journey = [
    {
      banner_image:
        'https://image.bajajcapitalone.com/bajajcapital/Our%20Journey.png',
      journey_description:
        'BajajCapital launched National Pension System Online Platform - A Complete paperless journey to enroll under NPS. Also, introduced Minor Account opening on Online MF platform. BajajCapital launched a COVID-19 specific health insurance policy.\r\n\r\nRecognised as "Great Place to Work "  in the industry.',
      journey_month: 'Jun',
      journey_nid: '907',
      journey_title: 'New Website Launch - 29th July 2020',
      journey_year: '2020',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2019.png",
      journey_nid: '967',
      journey_year: '2019',
      journey_month: 'Mar',
      journey_title: 'Awards and Accolades',
      journey_description:
        'BajajCapital has been inducted as Hall of Fame for exemplary contribution in financial advisory space over the past decade for the years 2018 - 19 and 2019-20 at the CNBC TV 18 10th Financial Advisor Awards 2018-19. Also, Adjudged as "Best Digital Transformation in Insurance/ Financial Services by Transformance Business Media in 2019. BajajCapital was certified as Great Place to Work Institute - India for 2018-19.',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2017.png",
      journey_nid: '968',
      journey_year: '2017',
      journey_month: 'Apr',
      journey_title: 'CNBC TV 18 Financial Advisor Awards',
      journey_description:
        'BajajCapital has been recognised as Best Performing National Financial Advisor - Retail at the CNBC TV 18 Financial Advisor Awards',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2016.png",
      journey_nid: '969',
      journey_year: '2016',
      journey_month: '',
      journey_title: 'Awards and Accolades',
      journey_description:
        "BajajCapital has been adjudged, 'Best BFSI Brand' at the CNBC TV 18 Financial Advisor Awards",
    },
    { 
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2015.png",
      journey_nid: '970',
      journey_year: '2015',
      journey_month: '',
      journey_title: 'CNBC TV 18 Financial Advisor Awards',
      journey_description:
        'Best Performing National Financial Advisor - Retail at the CNBC TV 18 Financial Advisor Awards',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2013.png",
      journey_nid: '971',
      journey_year: '2013',
      journey_month: '',
      journey_title: 'Best Performing National Financial Advisor',
      journey_description:
        'Awarded Best Performing National Financial Advisor - Retail at the CNBC TV 18 Financial Advisor Awards',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2012.png",
      journey_nid: '972',
      journey_year: '2012',
      journey_month: '',
      journey_title: 'Great Place to Work Institute',
      journey_description:
        'Recognised among Top 50 Companies as Great Place to Work Institute - India',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2011.png",
      journey_nid: '973',
      journey_year: '2011',
      journey_month: '',
      journey_title: 'Best Performing National Financial Advisor',
      journey_description:
        'Best Performing National Financial Advisor - Retail. Ranked 42nd Great Place to Work Institute - India',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2009.png",
      journey_nid: '974',
      journey_year: '2009',
      journey_month: '',
      journey_title:
        'Ranked 1st in the Investment Category - Great Place to Work Institute',
      journey_description:
        'Best Performing National Financial Advisor - Retail. Best Performing National Financial Advisor - Wealth Management Co. by Business Sphere 2008 - 2009.',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2008.png",
      journey_nid: '975',
      journey_year: '2008',
      journey_month: '',
      journey_title: 'Launch of Just Trade',
      journey_description:
        "BajajCapital launches Just Trade®, an online Platform for investing in Equities, Mutual Funds, IPO's",
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2007.png",
      journey_nid: '983',
      journey_year: '2007',
      journey_month: '',
      journey_title: 'New Product Launch',
      journey_description:
        'BajajCapital launches Stock Broking and Depository (Demat) Services (in one of its group company).',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2005.png",
      journey_nid: '984',
      journey_year: '2005',
      journey_month: '',
      journey_title: 'Encouraging Scientific and Holistic Investing',
      journey_description:
        'BajajCapital launches its software-based programme for encouraging scientific and holistic investing.',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2004.png",
      journey_nid: '985',
      journey_year: '2004',
      journey_month: '',
      journey_title: 'All India Insurance Broking Licence',
      journey_description:
        'BajajCapital obtains the All India Insurance Broking Licence and sets up over 200 Insurance Shops across the country, making BajajCapital a household name.',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2002.png",
      journey_nid: '986',
      journey_year: '2002',
      journey_month: '',
      journey_title: 'Financial Planning and Need-based Investing',
      journey_description:
        'The Company focuses on creating investor awareness about Financial Planning and Need-based Investing. BajajCapital also sponsors its team members for qualifying as Certified Financial Planners (CFPs), a coveted professional qualification.',
    },
    {
      banner_image: "https://image.bajajcapitalone.com/bajajcapital/2000.png",
      journey_nid: '987',
      journey_year: '2000',
      journey_month: '',
      journey_title: 'One-stop Financial Supermarket',
      journey_description:
        "BajajCapital implements its vision of being a 'One-stop Financial Supermarket'. It transforms its team of Investment Experts into Financial Planners.",
    },
  ];
  slideConfig = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    swipeToSlide: true,
    draggable: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  journey_title = 'Our Journey';
  journey_description =
    'BajajCapital has contributed to the growth of the Indian Capital Market at every step. In 1965, we were the first to innovate the Companies Fixed Deposit. Today, we are playing an active role in the growth of the Indian Mutual Fund industry. Here is a glimpse of our journey through the years.';
  leadership_title = 'Managing Directors';

  ngOnInit(): void {

    $('.tab-listing').on(
      'click',
      '.tab-list > a',
      function (this: HTMLElement, event: JQuery.ClickEvent) {
        event.preventDefault();

        var dataHref = $(this).data('target');
        $('#' + dataHref)
          .show()
          .siblings('.tab')
          .hide();
        $(this)
          .addClass('active')
          .parent()
          .siblings()
          .find('a')
          .removeClass('active');
      }
    );

    $(function () {
      $('.description-toggle').click(function (this: HTMLElement) {
        $(this)
          .toggleClass('active')
          .closest('.profile-card')
          .toggleClass('active');
      });

      function activeonScroll(cls: HTMLElement) {
        var scrollHeight = $(window).scrollTop() as number;
        var hrf = $(cls).data('href') as string;
        var thisPosition = $(hrf).offset()?.top as number;
        if (scrollHeight >= thisPosition - 101) {
          $(cls).addClass('active').siblings().removeClass('active');
        } else {
          $(cls).removeClass('active');
        }
      }

      $('.scroll_active').each(function (this: HTMLElement) {
        activeonScroll(this);
      });

      $(window).scroll(function () {
        $('.scroll_active').each(function (this: HTMLElement) {
          activeonScroll(this);
        });
      });

      $('.section-menu ul li a').click(function (
        this: HTMLElement,
        e: JQuery.ClickEvent
      ) {
        e.preventDefault();
        var hash = $(this).attr('href') as string;
        var ofst = ($(hash).offset()?.top as number) - 99;
        $('html, body').animate(
          {
            scrollTop: ofst,
          },
          1000,
          function () {}
        );
        e.stopPropagation();
      });
    });

    $(function () {
      $('.description-toggle').click(function (this: HTMLElement) {
        $(this)
          .toggleClass('active')
          .closest('.profile-card')
          .toggleClass('active');
      });

      function activeonScroll(cls: HTMLElement) {
        var scrollHeight = $(window).scrollTop() as number;
        var hrf = $(cls).data('href') as string;
        var thisPosition = $(hrf).offset()?.top as number;
        if (scrollHeight >= thisPosition - 101) {
          $(cls).addClass('active').siblings().removeClass('active');
        } else {
          $(cls).removeClass('active');
        }
      }

      $('.scroll_active').each(function (this: HTMLElement) {
        activeonScroll(this);
      });

      $(window).scroll(function () {
        $('.scroll_active').each(function (this: HTMLElement) {
          activeonScroll(this);
        });
      });

      $('.section-menu ul li a').click(function (
        this: HTMLElement,
        e: JQuery.ClickEvent
      ) {
        e.preventDefault();
        var hash = $(this).attr('href') as string;
        var ofst = ($(hash).offset()?.top as number) - 99;
        $('html, body').animate(
          {
            scrollTop: ofst,
          },
          1000,
          function () {}
        );
        e.stopPropagation();
      });
    });

    /// <reference types="jquery" />

    $('.selected-item').click(function (
      this: HTMLElement,
      e: JQuery.ClickEvent
    ) {
      $(this).toggleClass('active');
      $('.selected-item').not(this).removeClass('active');
      e.stopImmediatePropagation();
      return false;
    });

    /// <reference types="jquery" />

    $('.custom-dropdown ul li a').click(function (
      this: HTMLElement,
      e: JQuery.ClickEvent
    ) {
      $('.selected-item').removeClass('active');
      var selectedItem = $(this).text();

      $(this).parents().find('.selected-item').text(selectedItem);
      $(this).parent('li').addClass('active').siblings().removeClass('active');
      e.stopImmediatePropagation();
      return false;
    });
  }
}
